import './ServiceHighlights.css';
import arrowYellowVisual from '../assest/service-arrow-yellow.svg';
import arrowGreenVisual from '../assest/service-arrow-green.svg';
import arrowDarkVisual from '../assest/service-arrow-dark.svg';

const highlightCards = [
  {
    id: 'delivery',
    title: 'Quick and Effective Delivery',
    description:
      'We have a strong working relationship with courier services DPD and Royal Mail to ensure our customers receive their products efficiently.',
    visual: arrowYellowVisual,
  },
  {
    id: 'products',
    title: 'Thousands of Products',
    description:
      "Our inventory is vast. We have several vaping products to suit all our customers' needs! You will find something perfect for your store.",
    visual: arrowGreenVisual,
  },
  {
    id: 'rep',
    title: 'Your Personal Vape Rep',
    description:
      'We provide extensive support for those connected to the world of vaping. We are on hand to help you with any enquiries you may have.',
    visual: arrowDarkVisual,
  },
];

function ServiceHighlights() {
  return (
    <section className="service-highlights" aria-label="Key service highlights">
      <div className="service-highlights__grid">
        {highlightCards.map((card) => (
          <article key={card.id} className="service-highlights__card">
            <div className="service-highlights__content">
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </div>
            <div
              className="service-highlights__visual"
              style={{ backgroundImage: `url(${card.visual})` }}
              aria-hidden="true"
            />
          </article>
        ))}
      </div>
    </section>
  );
}

export default ServiceHighlights;
